import Chart1 from "components/Charts/Chart1"
import React, { useMemo, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Row,
  CardHeader,
  Button,
  Collapse,
  Spinner,
} from "reactstrap"
import { useSelector } from "react-redux"
import Chart2 from "components/Charts/Chart2"
import { isNaN } from "lodash"
import ProvinceStockFilter from "./ProvinceStockFilter"
import ProvinceStockItemlist from "./ProvinceStockItemList"

const ProvinceStockComponents = ({
  onCategoryChange,
  stocks,
  onAdvanceSearch,
  categories,
  onExportClicked,
  onAdvancedSearchHandle,
  allData,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [category, setCategory] = useState(categories?.data?.[0]?.label)
  const [searchDate, setSearchDate] = useState({
    fromDate: null,
    toDate: null,
  })

  let data = []
  if (stocks) {
    data = stocks?.map(stock => {
      const items = stock.item_name
      const in_qty = !isNaN(parseInt(stock.province_ins_sum_first_in_qty))
        ? parseInt(stock.province_ins_sum_first_in_qty)
        : 0

      const out_qty = !isNaN(parseInt(stock.province_outs_sum_out_quantity))
        ? parseInt(stock.province_outs_sum_out_quantity)
        : 0

      const balance = in_qty - out_qty
      return { items, in_qty, out_qty, balance }
    })
  }

  const exportStatus = useSelector(
    state => state.provinceDashboard.exportStatus
  )
  const provIpsStockLoading = useSelector(
    state => state.providerDashboard.providerIpsStock.loading
  )

  const getSearchData = values => {
    setSearchDate({
      fromDate: values.from ? values.from : null,
      toDate: values.to ? values.to : null,
    })
    if (values.category) {
      setCategory(values.categoryName)
    }
  }

  return (
    <CardBody>
      <Card>
        <CardHeader>
          <Row>
            <Col lg={6}>
              <Row>
                <Col
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ fontSize: 20 }}>
                    Province Stock ( {category})
                    {searchDate.fromDate && (
                      <p
                        style={{
                          fontSize: 15,
                          color: "#19ada1",
                          fontWeight: 700,
                        }}
                      >
                        ( {searchDate.fromDate} ) - ( {searchDate.toDate} )
                      </p>
                    )}
                  </span>
                  &nbsp;
                  {provIpsStockLoading && (
                    <Spinner
                      className="ms-1"
                      style={{ padding: 7, marginTop: 5 }}
                      size="sm"
                      color="primary"
                    />
                  )}
                </Col>
              </Row>
            </Col>
            <Col lg={6} style={{ textAlign: "right" }}>
              <Button
                onClick={onExportClicked}
                className="btn btn-info"
                disabled={exportStatus?.loading}
              >
                {exportStatus?.loading ? "Please Wait..." : "Export"}
              </Button>
              &nbsp;
              <Button
                onClick={() => {
                  setIsOpen(!isOpen)
                }}
                className="btn btn-success "
              >
                {isOpen ? "Hide" : "Search"}
              </Button>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <Collapse isOpen={isOpen}>
            <ProvinceStockFilter
              onCategoryChange={onCategoryChange}
              provIpsStockLoading={provIpsStockLoading}
              getSearchData={getSearchData}
              categories={categories}
              onAdvancedSearchHandle={onAdvancedSearchHandle}
            />
          </Collapse>
          <Chart2 data={data} />
          <ProvinceStockItemlist
            allData={allData}
            data={stocks}
            searchDate={searchDate}
          />
        </CardBody>
      </Card>
    </CardBody>
  )
}

export default ProvinceStockComponents
